import { Circle, Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function CartIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6.2" />
      <Circle cx="9" cy="20" r="1.4" />
      <Circle cx="17" cy="20" r="1.4" />
    </LineIcon>
  );
}
